import React from 'react';
import UnauthorizedComp from '../components/Auth/UnAuthorized';
import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const ForbiddenAccess = () => {
  return (
    <SuspenseLoadPage>
      <UnauthorizedComp
        message='Something went wrong please contact system administrator.'
        backOption
      />
    </SuspenseLoadPage>
  );
};

export default ForbiddenAccess;
